window.theme = window.theme || {};
(function ($) {
  "use strict";

  $(document).on('click', ".unlock-btn", function(e) {
    e.preventDefault();
    $(".ep-overlay").css({"display":"flex"});
    $(".unlock-popup-iframe-container").show();
    $(".ep-iFrameContainer").show();

  });


  $(document).on('click', ".ep-overlay, .ep-close-icon", function(e) {
    e.preventDefault();
    $(".ep-overlay").hide();
    $(".unlock-popup-iframe-container").hide();
    $(".ep-iFrameContainer").hide();
  });

  



})(jQuery);



class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");

    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
        : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");
    let scroll = this.querySelector(".swiper-scrollbar");

    new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay),
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      scrollbar: {
        el: scroll,
        draggable: true,
      },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
        },
        768: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
        },
        1024: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
        },
      },
    });
  }
}
customElements.define("slideshow-swiper", slideshowSwiper);


if (!customElements.get("collapsible-content")) {
  class collapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      this.panel = this.toggle.nextElementSibling;
      this.init();
    }

    init() {
      // Check if the content element has a CSS transition.
      if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
        this.toggle.addEventListener('click', this.handleToggle.bind(this));
        this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
      }
    }

    /**
     * Handles 'click' events on the summary element.
     * @param {object} evt - Event object.
     */
    handleToggle(evt) {
      evt.preventDefault();

      if (!this.disclosure.open) {
        this.open();
      } else {
        this.close();
      }
    }

    /**
     * Handles 'transitionend' events on the details element.
     * @param {object} evt - Event object.
     */
    handleTransitionEnd(evt) {
      if (evt.target !== this.panel) return;

      if (this.disclosure.classList.contains('is-closing')) {
        this.disclosure.classList.remove('is-closing');
        this.disclosure.open = false;
      }

      this.panel.removeAttribute('style');
    }

    /**
     * Adds inline 'height' style to the content element, to trigger open transition.
     */
    addContentHeight() {
      this.panel.style.height = `${this.panel.scrollHeight}px`;
    }

    /**
     * Opens the details element.
     */
    open() {
      // Set content 'height' to zero before opening the details element.
      this.panel.style.height = '0';

      // Open the details element
      this.disclosure.open = true;

      // Set content 'height' to its scroll height, to enable CSS transition.
      this.addContentHeight();
    }

    /**
     * Closes the details element.
     */
    close() {
      // Set content height to its scroll height, to enable transition to zero.
      this.addContentHeight();

      // Add class to enable styling of content or toggle icon before or during close transition.
      this.disclosure.classList.add('is-closing');

      // Set content height to zero to trigger the transition.
      // Slight delay required to allow scroll height to be applied before changing to '0'.
      setTimeout(() => {
        this.panel.style.height = '0';
      });
    }
  }
  customElements.define('collapsible-content', collapsibleContent);
}




var BEYHelper = window.BEYHelper || {};
BEYHelper.qs = document.querySelector.bind(document);
BEYHelper.qsa = document.querySelectorAll.bind(document);
BEYHelper.qid = document.getElementById.bind(document);
BEYHelper.qde = document.documentElement;


class KOBOLazyLoadingVideo extends HTMLElement {
  constructor() {
    super(),
      (this.iframe = this.querySelector("iframe")),
      (this.template = this.querySelector("template")),
      (this.isMouseenter = !1);
  }
  loadVideo() {
    var t;
    this.iframe &&
      (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
      this.iframe.addEventListener(
        "load",
        function () {
          "youtube" == this.dataVideoType &&
            this.iframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              "*"
            ),
            "vimeo" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
        }.bind(this)
      )),
      "local_video" == this.dataVideoType &&
        ((this.local_video = this.querySelector("video")),
        (t = this.local_video.querySelector("source").getAttribute("data-src")),
        (this.local_video.src = t));
  }
  execute() {
    Shopify.designMode
      ? this.loadVideo()
      : (["mousemove", "touchstart"].forEach(
          function (t) {
            BEYHelper.qs("body").addEventListener(
              t,
              function (t) {
                this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
              }.bind(this),
              { once: !0 }
            );
          }.bind(this)
        ),
        window.addEventListener(
          "scroll",
          function (t) {
            this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
          }.bind(this),
          { once: !0 }
        ));
  }
  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }
  set dataVideoType(t) {
    this.setAttribute("data-video-type", t);
  }
  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }
  set dataVideoId(t) {
    this.setAttribute("data-video-id", t);
  }
  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this.execute();
  }
  connectedCallback() {
    this.execute();
  }
  disconnectedCallback() {}
}
customElements.define("kobo-load-video", KOBOLazyLoadingVideo);




class KOBOLoadMedia extends HTMLElement {
  constructor() {
    super(),
      (this.$ = this.querySelector.bind(this)),
      (this.sectionID = this.dataset.sectionId),
      (this.idVideo = this.dataset.idVideo),
      (this.typeVideo = this.dataset.type),
      (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
      (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
      (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
      (this.trigger = this.$(".js-load-media-trigger")),
      this.trigger &&
        this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
  }
  handlePlayVideo() {
    this.classList.add("playing");
    this.loadContent();
    const t = this.querySelector(".js-media-item-video");
    t &&
      t.addEventListener("play", () => {
        this.pauseAllVideo(t), t.play();
      });
  }
  onYouTubeIframeAPIReady() {
    if ("undefined" != typeof YT && void 0 !== YT.Player)
      try {
        this.player = new YT.Player(this.eleVideo, {
          videoId: this.idVideo,
          playerVars: { playsinline: 1 },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (t) {
        console.error("Lỗi khi tạo trình phát YouTube:", t);
      }
    else {
      var t = document.createElement("script"),
        e =
          ((t.src = "https://www.youtube.com/iframe_api"),
          (t.onload = () => {
            this.onYouTubeIframeAPIReady();
          }),
          document.getElementsByTagName("script")[0]);
      e.parentNode.insertBefore(t, e);
    }
  }
  onVimeoIframeAPIReady() {
    if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
      try {
        var t = { id: this.idVideo, autoplay: 1 };
        (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
          this.playerVimeo.on("play", () => {
            this.pauseAllVideo(this.playerVimeo);
          });
      } catch (t) {
        console.error("Lỗi khi tạo trình phát Vimeo:", t);
      }
    else {
      var t = document.createElement("script"),
        e =
          ((t.src = "https://player.vimeo.com/api/player.js"),
          (t.onload = () => {
            this.onVimeoIframeAPIReady();
          }),
          document.getElementsByTagName("script")[0]);
      e.parentNode.insertBefore(t, e);
    }
  }
  onPlayerYTReady = () => {
    this.pauseAllVideo(this.player), this.player.playVideo();
  };
  onPlayerStateYTChange = (t) => {
    1 == t.data && this.onPlayerPlay();
  };
  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };
  loadContent() {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        var t = this.$("template").content.firstElementChild.cloneNode(!0);
        this.appendChild(t),
          this.isLoaded(!0),
          this.trigger && this.trigger.remove();
      } else {
        if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
        else {
          if ("vimeo" != this.typeVideo) return !0;
          this.onVimeoIframeAPIReady();
        }
        this.trigger?.classList.add("d-none"),
          this.$(".js-media-item").classList.add("d-flex");
      }
      return !0;
    }
  }
  pauseAllVideo(e) {
    BEYHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((t) => {
      t.player && e !== t.player && t.player?.pauseVideo();
    }),
      BEYHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='vimeo'])"
      ).forEach((t) => {
        t.playerVimeo !== e && t.playerVimeo?.pause();
      }),
      BEYHelper.qsa(".js-media-item-video").forEach((t) => {
        t !== e && t.pause();
      });
  }
  isLoaded(t) {
    t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
  }
}
customElements.define("kobo-load-media", KOBOLoadMedia);



gsap.registerPlugin(ScrollTrigger);

function storyScroll() {
    ScrollTrigger.batch(".story__section", { 
        toggleClass: "inView", 
        start: "top 65%" 
    });

    gsap.to(".story__timeline", { 
        scrollTrigger: { 
            trigger: ".story", 
            scrub: 1, 
            start: "top 50%", 
            end: "bottom 20%" 
        }, 
        height: "100%" 
    });
}
  storyScroll(); 




  if ($(window).width() < 767) {
    var lastScrollTop = 0; // Track the last scroll position

    $(window).scroll(function() {
        var top_of_element = $(".sticky-add").offset().top;
        var bottom_of_element = top_of_element + $(".sticky-add").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        // Prevent unnecessary toggling of class by comparing scroll direction and state
        if (top_of_screen >= bottom_of_element && top_of_screen > lastScrollTop) {
            // Add class if element is fully scrolled out of view and scrolling down
            if (!$(".sticky-add").hasClass('show-sticky')) {
                $(".sticky-add").addClass('show-sticky');
            }
        } else if (top_of_screen < bottom_of_element && top_of_screen < lastScrollTop) {
            // Remove class if element is in view and scrolling up
            if ($(".sticky-add").hasClass('show-sticky')) {
                $(".sticky-add").removeClass('show-sticky');
            }
        }

        // Update last scroll position
        lastScrollTop = top_of_screen;
    });
}
